import { ErrorHandler, Injectable, Injector, NgZone, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { TrackService } from '../tracking/track.service';
import { NotificationService } from '../notification/notification.service';
import { ErrorService } from './error.service';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong, Please try again.';
const SERVER_ERROR_CODE = 500;
const SERVER_ERROR_MESSAGE = 'An unexpected error occurred.';
@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService implements ErrorHandler {
  private injector = inject(Injector);
  private zone = inject(NgZone);

  handleError(error: Error | HttpErrorResponse): void {

    const errorService = this.injector.get(ErrorService);
    const tracker = this.injector.get(TrackService);
    const notifier = this.injector.get(NotificationService);

    let message = '';
    let stackTrace: string | undefined;
    if (error instanceof HttpErrorResponse) {
      //// server-side error
      message = errorService.getServerMessage(error);
      stackTrace = errorService.getServerStack(error);
      const statusCode = error.status;

      this.zone.run(() => {
        if (statusCode === SERVER_ERROR_CODE) {
          notifier.showInfo(SERVER_ERROR_MESSAGE);
        }
        if (message !== 'Not found.' && statusCode !== SERVER_ERROR_CODE) {
          notifier.showError(message ?? DEFAULT_ERROR_MESSAGE);
        }
        tracker.logError(message);
        tracker.logError(stackTrace || 'No stack trace available');
      });

    } else {
      //// client-side error
      message = errorService.getClientMessage(error);
      stackTrace = errorService.getClientStack(error);

      this.zone.run(() => {
        tracker.logError(message);
        tracker.logError(stackTrace || 'No stack trace available');
      });
    }

  }

  handleServerError(_error: any): void {
    //// Handle server-side errors
  }

  handleClientError(_error: any): void {
    //// Handle client-side errors
  }
}
